<template>
	<section class="hero">
		<div class="hero__container">
			<div class="hero__info" data-aos="fade-up">
				<div>
					<h1 class="hero__title">{{ data[0]?.title }}</h1>
					<p class="hero__description">{{ data[0]?.desc }}</p>
				</div>
				<div>
					<div class="hero__phone hero__phone--primary">
						<GlobalIcon name="note-text-bold" :width="24" />
						<span class="hero__phone-name">{{ $t('modules.contact_page_modules.contact_page_hero.infoline_name') }}</span>
						<div style="flex: 1"></div>
						<a :href="`tel:${data[0]?.phone_1}`" rel="nofollow">{{ data[0]?.phone_1 }}</a>
					</div>
				</div>
			</div>
			<ContactPageHeroForm :title="data[0]?.form" />
		</div>
	</section>
</template>

<script setup lang="ts">
import { ECMSType, ECMSPage, EContactPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const data = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()
const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')!

if (!pageSections) {
	try {
		const accordion = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.CONTACT, EContactPageSectionType.HEADER)
		if (accordion) data.value = accordion?.translations.find((t) => t.language === getLocaleLang())?.content
	} catch (error) {
		console.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section = newValue.find((section) => section.name === EContactPageSectionType.HEADER)
			if (section) {
				data.value = section.translations.find((t) => t.language === getLocaleLang())?.content
			}
		}
	},
	{ immediate: true, deep: true },
)
</script>

<style scoped lang="scss">
@import './ContactPageHero.scss';
</style>
